import { ModelBase, Property } from '@skylab-shared/core';
import { IntegrationType } from './queries/integrations-list.query-base';

export class IntegrationModel extends ModelBase {
	@Property({ identifiable: true })
	public accountGuid: string;

	@Property()
	public name: string;

	@Property({nullable: true})
	public providerAccountName: string;

	@Property()
	public authenticationType: string;

	@Property()
	public isActive: boolean;

	@Property()
	public isConnected: boolean;

	@Property()
	public providerType: IntegrationType;

	@Property(Date, {nullable: true})
	public lastSyncDate: Date | null;

	@Property(Date, {nullable: true})
	public createdDate: Date | null;

	@Property(Date, {nullable: true})
	public modifiedDate: Date | null;

	public override get isPersistent(): boolean {
		return this.accountGuid != null;
	}
}
